export default __webpack_public_path__ + "8fb9c9d161c3783da95b0d86db0c9f7d.png";